import { ICulturesState } from './types';

export const initialSelectors = {
  selectLoadedState: () => ({}),
  selectCultures: () => ({}),
  selectSyncError: () => ({}),
  selectSyncState: () => ({}),
};

export const selectLoadedState = (state: ICulturesState) => state.loaded;
export const selectCultures = (state: ICulturesState) => state.cultures;
export const selectSyncError = (state: ICulturesState) => state.error;
export const selectSyncState = (state: ICulturesState) => state.syncing;
